import { Middleware } from "@reduxjs/toolkit";

import { MetrikaService } from "src/services";
import { metrikaActions } from "src/store/actions";

export const metrikaMiddleware =
  (metrika: MetrikaService): Middleware =>
  () =>
  (next) =>
  (action) => {
    const response = next(action);

    switch (action.type) {
      case metrikaActions.send.type: {
        metrika.send(action.payload);
        break;
      }
    }

    return response;
  };
